module.exports = __webpack_public_path__ + "static/media/Cabs2.0-300-125-A.6dce77d6.png";